/**
 * Warehouse Insights API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Canonical human-readable category names shown on insight card summary badges.
 */
export const InsightCategory = {
    TrendsBenchmarking: 'Trends & Benchmarking',
    CriticalAlerts: 'Critical Alerts',
    OperatorRisk: 'Operator Risk',
    DriverRisk: 'Driver Risk',
    LocationRisk: 'Location Risk',
    AssetRisk: 'Asset Risk',
    AfterImpactInvestigations: 'After-Impact & Investigations',
    ScoringModelGovernance: 'Scoring Model Governance'
} as const;
export type InsightCategory = typeof InsightCategory[keyof typeof InsightCategory];

